import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconTelevision: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.4 5H21c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1h-8v1h2.5c.6 0 1 .4 1 1s-.4 1-1 1h-7c-.6 0-1-.4-1-1s.4-1 1-1H11v-1H3c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1h6.6L8.3 3.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L12 4.6l2.3-2.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L14.4 5zM4 7v10h16V7H4zm4.3 5.3l2-2c.4-.4 1-.4 1.4 0l1.3 1.3 1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-2 2c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3L11 12.4l-1.3 1.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4z',
    })
  )
}
